export const iconFontAwesomeHouseholdTemperatureArrowUp = (
	<i className="fa-solid fa-temperature-arrow-up"></i>
);
